import { ButtonHTMLAttributes } from "react";
import Icon from "../icon/Icon";
import { LucideIcon } from "lucide-react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant: "default" | "primary" | "ghost";
    size?: "small" | "medium" | "large";
    icon: LucideIcon;
};

const IconButton = ({
    icon,
    ...props
}: ButtonProps) => {
    const { variant = "default", size = "medium", className, ...rest } = props;

    const variantClass = {
        default: `bg-cloud border border-cloud-shade shadow 
        active:bg-cloud active:border-cloud-shade active:shadow-pressed 
        hover:bg-cloud-tint hover:border-cloud
        focus-visible:outline-none focus-visible:shadow-focus
        text-black`,
        primary: `bg-charcoal border border-charcoal-shade shadow
        active:bg-charcoal active:border-charcoal-shade active:shadow-pressed
        hover:bg-charcoal-tint
        focus-visible:outline-none focus-visible:shadow-focus
        text-white`,
        ghost: `bg-white border border-cloud-shade
        active:bg-cloud active:border-cloud-shade
        hover:bg-cloud-tint hover:border-cloud-shade
        focus-visible:outline-none focus-visible:shadow-focus
        text-black`,
    };

    const sizeClass = {
        small: "p-2 rounded-xs",
        medium: "p-2.5 rounded-sm",
        large: "p-4 rounded-md",
    };

    return (
        <button
            className={`inline-flex items-center justify-center ${variantClass[variant]} ${sizeClass[size]} ${props.className}
            disabled:opacity-30 disabled:cursor-not-allowed`}
            {...rest}
        >
            <Icon icon={icon} size={20} />
        </button>
    );
};

export default IconButton;